import { CHURCH, HUB_CARDS, PANELS, type PanelId } from '../config/church'
import type { Screen } from '../core/types'
import { icon } from './chrome'

/**
 * The hub. This is what a visitor sees the instant they touch the panel and
 * Fully's screensaver steps aside, so it has to answer "what can I do here?"
 * in one glance from standing distance.
 */
export function createHomeScreen(): Screen {
  let clock: number | undefined

  return {
    mount(root, ctx) {
      root.classList.add('screen--home')

      const panel = resolvePanel(ctx.param)

      const header = document.createElement('header')
      header.className = 'hub__header'

      const brand = document.createElement('div')
      brand.className = 'hub__brand'
      const nameKo = document.createElement('p')
      nameKo.className = 'hub__name-ko'
      nameKo.textContent = CHURCH.nameKo
      const nameEn = document.createElement('p')
      nameEn.className = 'hub__name-en'
      nameEn.textContent = CHURCH.nameEn
      brand.append(nameKo, nameEn)

      const when = document.createElement('div')
      when.className = 'hub__when'
      const renderClock = (): void => {
        when.textContent = formatNow()
      }
      renderClock()
      // Aligning to the minute boundary avoids a visible 1-second stutter.
      clock = window.setInterval(renderClock, 15_000)

      header.append(brand, when)
      root.appendChild(header)

      const grid = document.createElement('div')
      grid.className = 'hub__grid'
      for (const card of HUB_CARDS) {
        const button = document.createElement('button')
        button.type = 'button'
        button.className = 'hub-card'

        const glyph = document.createElement('span')
        glyph.className = 'hub-card__glyph'
        glyph.appendChild(icon(card.icon))

        const title = document.createElement('span')
        title.className = 'hub-card__title'
        title.textContent = card.title

        const subtitle = document.createElement('span')
        subtitle.className = 'hub-card__subtitle'
        subtitle.textContent = card.subtitle

        button.append(glyph, title, subtitle)
        button.addEventListener('click', () => ctx.go(card.target))
        grid.appendChild(button)
      }
      root.appendChild(grid)

      const footer = document.createElement('footer')
      footer.className = 'hub__footer'
      footer.textContent = panel ? `${PANELS[panel]} · ${CHURCH.site}` : CHURCH.site
      root.appendChild(footer)
    },

    unmount() {
      if (clock !== undefined) window.clearInterval(clock)
    },
  }
}

function resolvePanel(param: string | undefined): PanelId | undefined {
  return param && param in PANELS ? (param as PanelId) : undefined
}

const WEEKDAYS = ['일', '월', '화', '수', '목', '금', '토'] as const

function formatNow(): string {
  const now = new Date()
  const weekday = WEEKDAYS[now.getDay()] ?? ''
  const hours = now.getHours()
  const minutes = String(now.getMinutes()).padStart(2, '0')
  const meridiem = hours < 12 ? '오전' : '오후'
  const hour12 = hours % 12 === 0 ? 12 : hours % 12
  return `${now.getMonth() + 1}월 ${now.getDate()}일 (${weekday}) · ${meridiem} ${hour12}:${minutes}`
}
